import { Injectable } from 'framework/di';

@Injectable
export class DomHelper {
  validateHTMLElement(element: unknown) {
    if (element instanceof HTMLElement) {
      return element;
    }

    return null;
  }

  observeElementInViewport(
    element: HTMLElement | [HTMLElement],
    callback: (element: HTMLElement) => void,
    options?: {
      root?: Element | null;
      rootMargin?: string;
      threshold?: number | number[];
    }
  ) {
    const elements = Array.isArray(element) ? element : [element];
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback(entry.target as HTMLElement);
        }
      });
    }, options);

    elements.forEach((el) => {
      observer.observe(el);
    });

    return () => {
      elements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }

  handleClickOutside(rootElm: HTMLElement, callback: (target: EventTarget) => void) {
    const onClick = (event) => {
      if (!rootElm.contains(event.target)) {
        callback(event.target);
        document.removeEventListener('click', onClick);
      }
    };

    document.addEventListener('click', onClick);

    return () => document.removeEventListener('click', onClick);
  }
}
